export { default } from "./PricingCard";
